import { React } from "react";
import './App.css';
import Home from "./Home";
import Header from "./Header";
import Result from "./Result";
//import Swipe from "./Swipe";
import QuestionBoard from "./QuestionBoard";
import { HashRouter as Router, Route } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import ScrollToTop from "./ScrollToTop";
import Result2 from "./Result2";
import QuestionBoard2 from "./QuestionBoard2";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    color: "#388e3c",
    backgroundColor: "#81c784"
  },

  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1,
    textAlign: "center"
  },
  labelPlacementTop: {
    fontSize: 9
  }
}));

function App() {
  const classes = useStyles();
  console.log()
  return (
    <div className={classes.root}>
      <Router>
        <div>
          <Header></Header>
          <Route exact path="/" component={Home} />
          <Route path="/First" component={QuestionBoard}></Route>
          <ScrollToTop>
            <Route path="/Result" component={Result}></Route>
          </ScrollToTop>
          <ScrollToTop>
            <Route path="/Result2" component={Result2}></Route>
          </ScrollToTop>
          <ScrollToTop>
            <Route path="/Second" component={QuestionBoard2}></Route>
          </ScrollToTop>
        </div>
      </Router>
    </div>
  )
}


export default App;
